import {Environment} from '../../src/Environment';

export const CONFIG = {
    environment: Environment.ENVIRONMENT_DEVELOPMENT, // PRODUCTION // DEVELOPMENT
    mode: Environment.MODE_STANDARD,

    // base_url: 'http://10.0.30.39/m2epro/a.yatin/other_projects/'
    // base_url: 'http://authentication.auth/'
    base_url: 'http://localhost:3000/'
};
